import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * "This host resolves to no business."
 *
 * The one screen a slug-less public page can honestly show when
 * `useRouteSalonSlug` comes back with `salonSlugUnresolved` — the branded
 * domain resolved when the server sent the HTML and no longer does now
 * (unlinked, suspended, API blip). Saying "this shop has no products yet" or
 * "no courses are open" there would blame the business for a domain that is
 * simply not pointing anywhere.
 *
 * It reuses `salon_not_found_title` / `salon_not_found_sub`, the sentences Home
 * already shows for an unknown business — already written in en / he / ar, so
 * every reader gets this in their own language and the product says one thing
 * about one situation. Colours are tokens (`--section-title-color`,
 * `--color-navy`), which the salon themes and dark mode remap, so this screen
 * follows the business's own palette like everything around it.
 */
export default function BusinessNotFound() {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      data-testid="business-not-found"
      style={{
        padding: '64px 24px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700, color: 'var(--section-title-color)' }}>
        {t('salon_not_found_title')}
      </h2>
      <p style={{ margin: 0, maxWidth: 420, color: 'var(--color-navy)', opacity: 0.7 }}>
        {t('salon_not_found_sub')}
      </p>
    </div>
  );
}
